<template>
  <el-dialog title="个人中心"
    :visible.sync="$parent.personalDialog"
    width="30%">
    <el-tabs v-model="activeName"
      @tab-click="handleClick"
      type="card">
      <el-tab-pane v-for="v in cardList"
        :key="v.key"
        :label="v.name"
        :name="v.key">
        <AccountInformation v-if="activeName==='account'" />
        <BuildingsShow v-if="activeName==='buildings'" />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import BuildingsShow from "@/components/gerenzhongxin/BuildingsShow";
import AccountInformation from "./AccountInformation";
export default {
  components: {
    BuildingsShow,
    AccountInformation,
  },
  data() {
    return {
      cardList: [
        { name: "账号信息", key: "account" },
        { name: "建筑信息", key: "buildings" },
      ],
      activeName: "account",
    };
  },
  methods: {
    handleClick() {},
  },
  created() {},
};
</script>

<style>
</style>